<style>
    .facetFilter {
        width: 75%;
        border: #e4e4e4;
        border-style: solid;
        border-width: 1px;
        border-radius: 5px;
    }
    .facetList {
        /* height: 125px; */
        width: 100%;
        overflow-x: auto;
        border: 0px;
    }
    .facet {
        margin-top: 13px;
    }

    /* width */
    ::-webkit-scrollbar {
        width: 10px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: #f1f1f1; 
        border-radius: 20px;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #888; 
        border-radius: 20px;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #555; 
    }

    ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: #2f4050;
        opacity: 1; /* Firefox */
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #2f4050;
    }

    ::-ms-input-placeholder { /* Microsoft Edge */
        color: #2f4050;
    }

    select option {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: block;
    }
    div label {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: block;
    }
    .fa.fa-filter {
        position: absolute;
        top: 5px;
        cursor: pointer;
        margin-left: 4px;
        font-size: 1.4em;
        color: var(--accent-blue);
    }
    .fa.fa-filter:hover {
        color: #0dbdff91;
    }
    .fa.fa-filter.filter-slash {
        color: var(--danger);
    }
    .fa.fa-filter.filter-slash:hover {
        color: #ff4e199e;
    }
    .fa.fa-filter.filter-slash::after {
        position: absolute;
        content: "/";
        color: #f9f9f9;
        font-weight: 900;
        right: 3px;
        top: -7px;
        font-size: 1.6em;
    }
</style>

<div [ngClass]="{'facet': !multiple}">
    <div style="position: relative;" [ngClass]="{'m-b-sm': multiple}">
        <input #inputField [(ngModel)]="filter" (input)="valueChange($event.target.value)" class="facetFilter" [placeholder]="category" style="font-size: large; padding-left: 8px;">
        <i class="fa fa-search" style="position: absolute; top: 7px; right: 27%"></i>
        <i *ngIf="multiple && !hideFilters" class="fa fa-filter" (click)="addFacet(undefined, true)" style="right: 25px;"></i>
        <i *ngIf="multiple && selectedFacet && selectedFacet.length && !hideFilters" class="fa fa-filter filter-slash" style="right: 0px;" (click)="onReset()"></i>
    </div>
    <div *ngIf="multiple && hideFilters" style="position: relative;" [ngClass]="{'m-b-sm': multiple}">
        <label>
            <input style="width: 16px; margin-left: 20px;" type="checkbox"
                [checked]="isSelectAll"
                (change)="selectAll()">Select All
        </label>
    </div>
    <select *ngIf="!multiple"
        [ngStyle]="{'height': filterListHeight}"
        [(ngModel)]="selectedFacet" 
        class="align-left facetList" 
        multiple="" 
        (change)="addFacet()"
        style="overflow-x: hidden; padding-left: 0;">
        <option *ngFor="let item of items" [ngValue]="item.value">
            {{showCount ? item.value + ' - (' + (item.count ? item.count : '') + ')' : item.value}}</option>
    </select>
    <div *ngIf="multiple"
        [ngStyle]="{'max-height': filterListHeight}" 
        class="align-left facetList"
        style="overflow-x: hidden; padding-left: 0;">
        <label *ngFor="let item of items">
            <input style="width: 16px;" type="checkbox" [value]="item.value" [ngStyle]="{'margin-left': hideFilters ? '20px' : '0px'}"
                [checked]="selectedFacet?.indexOf(item.value) >= 0"
                (change)="addFacet(item.value, false)">{{showCount ? item.value + ' - (' + (item.count ? item.count : '') + ')' : item.value}}
        </label>
    </div>
</div>
